import React, { useState, useEffect } from 'react';

/**
 * OfflineBanner - Shows when the browser loses network connectivity.
 * Auto-hides when connection is restored.
 */
const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div style={{
      background: 'rgba(245, 158, 11, 0.15)',
      borderBottom: '1px solid rgba(245, 158, 11, 0.4)',
      color: '#fbbf24',
      textAlign: 'center',
      padding: '8px 16px',
      fontSize: '0.85rem',
      fontWeight: 500,
      zIndex: 1000,
    }}>
      You're offline — some features may be unavailable until your connection is restored.
    </div>
  );
};

export default OfflineBanner;
